import { FormEvent, useState } from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import isEmail from 'validator/lib/isEmail'
import { Button, Header, TextInput } from 'components/common'
import { axiosBase } from 'utils/functions'
import { getCsrfToken } from 'utils/csrf'
import PublicPageContainer from './PublicPageContainer'
import './AuthPages.scss'

function UnlockInstructionsPage() {
  const { t } = useTranslation('pub', {
    keyPrefix: 'PublicRoutes.auth',
  })
  const [email, setEmail] = useState('')
  const [success, setSuccess] = useState('')
  const [error, setError] = useState('')
  const [isSubmitting, setIsSubmitting] = useState(false)

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    setError('')
    setSuccess('')

    if (!isEmail(email)) {
      setError(t('login.invalid'))
      return
    }

    setIsSubmitting(true)

    try {
      await axiosBase.post(
        '/users/unlock',
        { user: { email } },
        { headers: { 'x-csrf-token': getCsrfToken() } },
      )

      setSuccess(t('unlock.emailSent'))
    } catch (_error) {
      setError(t('unlock.unableToSend'))
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <PublicPageContainer>
      <div className="auth-page">
        <div className="auth-card">
          <Header as="h3" className="auth-title">
            {t('unlock.sendUnlockInstructions')}
          </Header>

          <form className="auth-form" onSubmit={handleSubmit} noValidate>
            <TextInput
              id="unlock-email"
              type="email"
              label={t('all.email')}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="email"
              fullBorder
              error={error}
            />

            {success ? <div className="auth-success">{success}</div> : null}

            <Button color="blue" type="submit" loading={isSubmitting}>
              {t('unlock.sendUnlockInstructions')}
            </Button>
          </form>

          <hr className="auth-divider" />
          <Link className="auth-link" to="/login">
            {t('all.login')}
          </Link>
        </div>
      </div>
    </PublicPageContainer>
  )
}

export default UnlockInstructionsPage
